import { cn } from "@/lib/cn";

type Size = "xs" | "sm" | "md" | "lg" | "xl";

const SIZES: Record<Size, string> = {
  xs: "h-6 w-6 text-[10px]",
  sm: "h-8 w-8 text-xs",
  md: "h-10 w-10 text-sm",
  lg: "h-16 w-16 text-lg",
  xl: "h-24 w-24 text-2xl",
};

type Props = {
  src?: string | null;
  name?: string | null;
  size?: Size;
  className?: string;
};

/**
 * Avatar com fallback automatico pra letra inicial quando nao ha imagem.
 * Usado no Topbar, UserMenu e pagina de perfil.
 */
export function Avatar({ src, name, size = "md", className }: Props) {
  const sizeClasses = SIZES[size];
  const initial = (name ?? "?").trim().charAt(0).toUpperCase() || "?";

  if (src) {
    return (
      <img
        src={src}
        alt={name ?? "avatar"}
        className={cn(
          "rounded-full object-cover",
          sizeClasses,
          className,
        )}
      />
    );
  }

  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-full bg-zinc-900 font-semibold text-white",
        sizeClasses,
        className,
      )}
    >
      {initial}
    </div>
  );
}
